import { useNavigate } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import PageHero from '../../components/feature/PageHero';

const WHATSAPP_URL = 'https://wa.me/5511913278081?text=Ol%C3%A1%2C%20preciso%20de%20atendimento%20jur%C3%ADdico%20urgente.';

const areas = [
  {
    icon: 'ri-shield-keyhole-line',
    titulo: 'Criminal',
    tag: 'Direito Penal',
    descricao: 'Defesa técnica e estratégica em todas as fases do processo criminal — do flagrante ao tribunal do júri, passando por habeas corpus, execução penal e recursos em todas as instâncias.',
    servicos: ['Flagrante e Delegacia', 'Audiência de Custódia', 'Habeas Corpus', 'Tribunal do Júri', 'Execução Penal', 'Acompanhamento de Inquérito'],
    href: '/atuacao/criminal',
  },
  {
    icon: 'ri-building-2-line',
    titulo: 'Penal Empresarial',
    tag: 'Compliance e Risco',
    descricao: 'Assessoria jurídica preventiva e defensiva para empresas e executivos em questões criminais, com foco em compliance, crimes tributários e gestão estratégica de riscos jurídicos.',
    servicos: ['Compliance Criminal', 'Crimes Tributários', 'Lavagem de Capitais', 'Crimes Corporativos', 'Defesa de Executivos', 'Gestão de Risco'],
    href: '/atuacao/penal-empresarial',
  },
  {
    icon: 'ri-scales-3-line',
    titulo: 'Civil',
    tag: 'Direito Civil',
    descricao: 'Atuação em contratos, responsabilidade civil, família, previdenciário e resolução de conflitos. Assessoria preventiva e contenciosa para pessoas e empresas.',
    servicos: ['Contratos e Negócios', 'Responsabilidade Civil', 'Direito de Família', 'Direito Previdenciário', 'Assessoria Preventiva', 'Locação e Imóveis'],
    href: '/atuacao/civil',
  },
];

export default function AtuacaoPage() {
  const navigate = useNavigate();

  return (
    <main className="font-sans">
      <Header />
      <PageHero
        tag="Especialização"
        titulo="Áreas de"
        tituloItalico="Atuação"
        subtitulo="Assessoria jurídica completa para pessoas e empresas, com atuação sólida nas esferas criminal e civil."
      />

      {/* Intro */}
      <section className="py-[60px] bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-3xl mx-auto text-center">
            <p className="font-sans text-[#0A1829]/65 text-base leading-relaxed">
              O escritório Moreira Tófoli Advogados atua nas principais áreas do Direito com profundidade técnica e visão estratégica. Cada área de atuação é conduzida com foco no melhor resultado possível para o cliente, com atendimento personalizado e direto com o advogado responsável pelo caso.
            </p>
          </div>
        </div>
      </section>

      {/* Áreas */}
      <section className="py-[60px] bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="space-y-6">
            {areas.map((area) => (
              <div
                key={area.titulo}
                className="grid lg:grid-cols-2 gap-0 rounded-lg overflow-hidden border border-[#E9D59C]/40"
              >
                {/* Image side */}
                <div className="relative bg-[#0A1829] flex items-center">
                  <div className="absolute inset-0 opacity-15">
                    <img
                      src={`https://readdy.ai/api/search-image?query=dramatic%20elegant%20legal%20environment%20dark%20navy%20blue%20gold%20premium%20law%20firm%20sophisticated%20minimalist%20design%20judicial%20atmosphere%20professional%20justice%20symbolism%20high%20contrast&width=600&height=320&seq=atuacao-${area.titulo.toLowerCase().replace(' ', '-')}&orientation=landscape`}
                      alt={area.titulo}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="relative z-10 p-10 lg:p-12">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#B39B62]/15 border border-[#B39B62]/30 mb-5">
                      <i className={`${area.icon} text-[#B39B62] text-xl`}></i>
                    </div>
                    <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase block mb-2">{area.tag}</span>
                    <h2 className="font-serif text-3xl lg:text-4xl text-white font-light mb-4">{area.titulo}</h2>
                    <p className="font-sans text-white/55 text-sm leading-relaxed">{area.descricao}</p>
                  </div>
                </div>

                {/* Content side */}
                <div className="bg-[#F8F5EE] p-10 lg:p-12 flex flex-col justify-between">
                  <div>
                    <h3 className="font-sans text-xs font-semibold text-[#B39B62] tracking-[0.2em] uppercase mb-5">Serviços incluídos</h3>
                    <ul className="grid grid-cols-2 gap-x-6 gap-y-3 mb-8">
                      {area.servicos.map((s) => (
                        <li key={s} className="flex items-center gap-2 text-sm font-sans text-[#0A1829]/65">
                          <span className="w-1 h-1 rounded-full bg-[#B39B62] shrink-0"></span>
                          {s}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="flex flex-col sm:flex-row gap-3">
                    <a
                      href={area.href}
                      onClick={(e) => { e.preventDefault(); navigate(area.href); }}
                      className="inline-flex items-center justify-center gap-2 bg-[#0A1829] hover:bg-[#B39B62] text-white hover:text-[#0A1829] font-sans font-semibold text-sm px-6 py-3 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
                    >
                      Saiba mais
                      <i className="ri-arrow-right-line text-sm"></i>
                    </a>
                    <a
                      href={WHATSAPP_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center gap-2 border border-[#0A1829]/25 text-[#0A1829] hover:border-[#B39B62] hover:text-[#B39B62] font-sans font-medium text-sm px-6 py-3 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-whatsapp-line text-sm"></i>
                      Consultar agora
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-[60px] bg-[#0A1829] text-center">
        <div className="max-w-2xl mx-auto px-6">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#B39B62]"></span>
            <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
              Vamos conversar
            </span>
            <span className="h-px w-10 bg-[#B39B62]"></span>
          </div>
          <h2 className="font-serif text-3xl lg:text-4xl text-white font-light mb-4">
            Não encontrou o que procurava?{' '}
            <span className="italic text-[#E9D59C]">Fale conosco</span>
          </h2>
          <p className="font-sans text-white/55 text-base leading-relaxed mb-8">
            Nossa equipe avalia cada caso com atenção. Entre em contato para uma consulta inicial.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#B39B62] hover:bg-[#E9D59C] text-[#0A1829] font-sans font-semibold text-base px-10 py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Falar com advogado
          </a>
        </div>
      </section>

      <Footer />
    </main>
  );
}
